var first_time_execution = true;
$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        statusCode: {
            401: function (jqxhr, textStatus, errorThrown) {
                location.reload(true);
            },
            405: function (jqxhr, textStatus, errorThrown) {
                location.href = "/login";
            },
        },
    });

    $(".bootstrap-select>button.btn").css({
        padding: "6",
        "text-transform": "capitalize",
    });

    window.CheckBoxClick = function (el) {
        if (el.checked) {
            el.value = 1;
        } else {
            el.value = 0;
        }
    }

    $(document).ajaxStart(function (event, jqXHR) {
        if (window.first_time_execution == false) {
            $("#overlay-spinner").fadeIn("fast"); //.delay(2000);
        }
    });

    //This is called after all the AJAX request are stopped.
    $(document).ajaxStop(function (event, jqXHR) {
        //Hide spinner
        if (window.first_time_execution == false) {
            $("#overlay-spinner").fadeOut("fast"); //.delay(2000);
        }
    });

    $(document).on("click", "#btn-schedule", function () {
        $("#col-schedule-day").fadeToggle(); //.toggleClass('d-none');
        $("#col-content").fadeIn("fast").toggleClass("col-xl-12");
    });

    $("#overlay-spinner").fadeOut();

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "date-br-pre": function (a) {
            if (a == null || a == "") {
                return 0;
            }
            var brDatea = a.split("/");
            return (brDatea[2] + brDatea[1] + brDatea[0]) * 1;
        },

        "date-br-asc": function (a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        },

        "date-br-desc": function (a, b) {
            return a < b ? 1 : a > b ? -1 : 0;
        },
    });
});

$(".slpicker").selectpicker({ noneSelectedText: '----' });

window.addEventListener("DOMContentLoaded", function () {
    //load just structure
    setTimeout(function () {
        window.first_time_execution = false;
    }, 2000);
});

window.timeConvert = function timeConvert(n) {
    let num = n;
    let hours = num / 60;
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);

    if (rhours > 0 && rminutes > 0) {
        return rhours + "h" + rminutes + "m";
    }
    if (rhours > 0 && rminutes < 1) {
        return rhours + "h";
    }
    if (rhours < 1 && rminutes > 0) {
        return rminutes + "m";
    }

    return 0;
};

window.isObjectEmpty = function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
};

window.loadPopoverAndTooltip = function loadPopoverAndTooltip() {
    let _popover = $('[data-bs-toggle="popover"]');
    if (_popover.length > 0) {
        _popover.each(function (index, item) {
            if ($(item).data("bs-content") ?? false) {
                if ($(item).data("bs-content").length > 0) {
                    $(item).popover();
                }
            }
        });
    }

    let _tooltip = $('[data-bs-toggle="tooltip"]');
    if (_tooltip.length > 0) {
        _tooltip.each(function (index, item) {
            if ($(item).data("bs-content") ?? false) {
                if ($(item).data("bs-content").length > 0) {
                    $(item).tooltip();
                }
            }
        });
    }
};

window.dataURIToBlob = function dataURIToBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);
    if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to  typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
};

let searchParams = new URLSearchParams(window.location.search);
let dateInterval = searchParams.get("start_date");
let start = moment();
let end = moment();

if (dateInterval) {
    dateInterval = dateInterval.split(" - ");
    start = dateInterval[0];
    end = dateInterval[1];
}

$(".date-range-picker").daterangepicker({
    showDropdowns: true,
    showWeekNumbers: true,
    alwaysShowCalendars: true,
    startDate: start,
    endDate: end,

    locale: {
        format: "DD/MM/YYYY",
        customRangeLabel: "Customizar",
        applyLabel: "Ok",
        cancelLabel: "Cancelar",
        monthNames: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dec"],
        daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    },
    ranges: {
        Hoje: [moment(), moment()],
        "Últimos 7 dias": [moment().subtract(7, "days"), moment()],
        "Últimos 15 dias": [moment().subtract(15, "days"), moment()],
        "Últimos 30 dias": [moment().subtract(30, "days"), moment()],
        "Este mês": [moment().startOf("month"), moment().endOf("month")],
    },
});

window.numFormatDatatable = $.fn.dataTable.render.number(".", ",", 2, '').display;

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: PT_BR
 */
jQuery.extend(jQuery.validator.messages, {
    required: "Este campo &eacute; obrigatório.",
    remote: "Por favor, corrija este campo.",
    email: "Forne&ccedil;a um endere&ccedil;o eletr&ocirc;nico v&aacute;lido.",
    url: "Forne&ccedil;a uma URL v&aacute;lida.",
    date: "Forne&ccedil;a uma data v&aacute;lida.",
    dateISO: "Forne&ccedil;a uma data v&aacute;lida (ISO).",
    number: "Forne&ccedil;a um n&uacute;mero v&aacute;lido.",
    digits: "Forne&ccedil;a somente d&iacute;gitos.",
    creditcard: "Forne&ccedil;a um cart&atilde;o de cr&eacute;dito v&aacute;lido.",
    equalTo: "Forne&ccedil;a o mesmo valor novamente.",
    accept: "Forne&ccedil;a um valor com uma extens&atilde;o v&aacute;lida.",
    maxlength: jQuery.validator.format("Forne&ccedil;a n&atilde;o mais que {0} caracteres."),
    minlength: jQuery.validator.format("Forne&ccedil;a ao menos {0} caracteres."),
    rangelength: jQuery.validator.format("Forne&ccedil;a um valor entre {0} e {1} caracteres de comprimento."),
    range: jQuery.validator.format("Forne&ccedil;a um valor entre {0} e {1}."),
    max: jQuery.validator.format("Forne&ccedil;a um valor menor ou igual a {0}."),
    min: jQuery.validator.format("Forne&ccedil;a um valor maior ou igual a {0}."),
});

window.setFormValidation = function setFormValidation(id) {
    $(`${id}`).validate({
        highlight: function (element) {
            inputMarqueStatus("danger", element);
        },
        success: function (element) {
            inputMarqueStatus("success", element);
        },
        errorPlacement: function (error, element) {
            printErrorMessage(error, element);
        },
    });
};

window.inputMarqueStatus = function inputMarqueStatus(status, element) {
    switch (status) {
        case "success":
            $(element).closest(".label-group").removeClass("has-danger").addClass("has-success");
            $(element).closest(".form-group").removeClass("has-danger").addClass("has-success");
            $(element).closest(".form-check").removeClass("has-danger").addClass("has-success");
            $(element).closest(".z-group").removeClass("has-danger").addClass("has-success");
            $(element).closest(".z-group").find("label.error").remove();
            break;
        case "danger":
            $(element).closest(".label-group").removeClass("has-success").addClass("has-danger");
            $(element).closest(".form-group").removeClass("has-success").addClass("has-danger");
            $(element).closest(".form-check").removeClass("has-success").addClass("has-danger");
            $(element).closest(".z-group").removeClass("has-success").addClass("has-danger");
            break;
    }
};

window.printErrorMessage = function printErrorMessage(label_error, element) {
    $(element).closest(".label-group").append(label_error);
    $(element).closest(".form-group").append(label_error);
    $(element).closest(".z-group-content").append(label_error);
};

window.objectifyForm = function objectifyForm(element) {
    var element = element.serializeArray();
    var data = {};
    element.map(function (x) {
        if (!x.name.includes("[]")) {
            return (data[x.name] = x.value);
        }
    });

    return data;
};

window.errorMessage = function errorMessage(dataErrors) {
    jQuery.each(dataErrors, function (input_name, value) {
        let element = document.querySelector(`[name=${input_name}]`);
        let label = document.querySelector(`[for=${input_name}]`);
        let input_id = document.querySelector(`[name=${input_name}]`).getAttribute("id");
        let text_error = value.pop();
        let label_error = createLabelError(input_id, text_error);
        printErrorMessage(label_error, element);
        inputMarqueStatus("danger", element);
    });
};

window.errorAlertMessage = function errorAlertMessage(dataErrors, element = "body", align = "center") {
    jQuery.each(dataErrors, function (input_name, value) {
        let text_error = value.pop();
        showNotification("bottom", align, text_error, "warning bold", element);
    });
};

window.errorAlertMessageLisHtml = function errorAlertMessageLisHtml(dataErrors, element = "body", align = "center") {
    let array = [];
    $.each(dataErrors, function (idx2, val2) {
        let str = "<p style='margin: 0px'>" + val2 + "</p>";
        array.push(str);
    });
    let html = array.join("");
    return "<div style='width: 100%;'>" + html + "</div>";
};

window.createLabelError = function createLabelError(input_id, text_error) {
    let label_id = `${input_id}-error`;
    let label = document.createElement("label");
    label.setAttribute("id", label_id);
    label.setAttribute("class", "error");
    label.setAttribute("for", input_id);
    label.textContent = text_error;

    return label;
};

window.saveFormAjax = function saveFormAjax(url, data, method, urlRedirect = false, global = false, show = true) {
    $.ajax({
        url: url,
        method: method,
        data: data,
        global: global,
    })
        .then(function (data) {
            if (show) {
                showNotification("bottom", "right", "Salvo.");
            }
            redirectTo(urlRedirect);
        })
        .catch(function (data, textStatus, jqXHR) {
            if (show) {
                showNotification("bottom", "right", "Ocorreu uma falha.", "danger");
            }
            errorMessage(data.responseJSON.errors);
        });
};

window.saveFormAlertAjax = function saveFormAlertAjax(
    url,
    data,
    method,
    urlRedirect = false,
    global = false,
    show = true,
    element = null,
) {
    disableElement(element, true);

    $.ajax({
        url: url,
        method: method,
        data: data,
        global: global,
    })
        .then(function (data) {
            if (data.message) {
                disableElement(element, false);
                showNotification("bottom", "right", data.message);
            }
            if (urlRedirect) {
                redirectTo(urlRedirect);
            }
        })
        .catch(function (data, textStatus, jqXHR) {
            disableElement(element, false);
            errorAlertMessage(data.responseJSON.errors);
        });
};

window.saveFormAlertModalAjax = function saveFormAlertModalAjax(config) {
    config.url = config.url ?? "#";
    config.method = config.method ?? "";
    config.data = config.data ?? {};
    config.global_loader = config.global_loader ?? false;
    config.target_alert = config.target_alert ?? "body";
    config.url_redirect = config.url_redirect ?? false;
    config.button = config.button ?? null;
    disableElement(config.button, true);
    $.ajax({
        url: config.url,
        method: config.method,
        data: config.data,
        global: config.global_loader,
    })
        .then(function (data) {
            if (data.message) {
                disableElement(config.button, false);
                showNotification("bottom", "center", data.message, "success", config.target_alert);
            }
            if (config.url_redirect) {
                redirectTo(config.url_redirect);
            }
        })
        .catch(function (data, textStatus, jqXHR) {
            disableElement(config.button, false);
            if (data.responseJSON.data == false) {
                showNotification("bottom", "center", data.responseJSON.message, "danger", config.target_alert);
            }
            if (!(data.responseJSON.data == false)) {
                errorAlertMessage(data.responseJSON.errors, config.target_alert);
            }
        });
};

window.getMethod = function getMethod(element, status) {
    let method = $("[name=_method]").val();
    method = method ? method : "POST";
    return method;
};

window.disableElement = function disableElement(element, status) {
    if (element) {
        let discountStatus = status;

        if (discountStatus) {
            let classChecked =
                element.attr("type") == "checkbox" && element.attr("data-spin") == "true" ? "zoop-checked-load" : "";
            if (classChecked) {
                element.before(
                    `<i class='zoop-gradient-icon fa-solid fa-spinner fa-spin font-size-24 ${classChecked}'></i>`,
                );
            }
            element.addClass("d-none");
            element.addClass("disabled");
            element.attr("disabled", true);
        }
        if (!discountStatus) {
            element.removeClass("d-none");
            element.removeClass("disabled");
            setTimeout(function () {
                element.attr("disabled", false);
                $(".zoop-gradient-icon").remove();
            }, 1500);
        }
    }
};

window.showNotification = function showNotification(from, align, msg, type = "success", element = "body") {
    $.notify(
        { icon: "  ", message: msg },
        {
            element: element,
            type: type,
            timer: 4000,
            placement: {
                from: from,
                align: align,
            },
        },
    );
};

function redirectTo(route) {
    if (route) {
        window.location.href = route;
    }
}

window.setMoneyMask = function setMoneyMask(input) {
    input.maskMoney({
        thousands: ".",
        decimal: ",",
    });
};

window.setCheck = function setCheck(input) {
    input.prop("checked", true);
};

window.setUncheck = function setUncheck(input) {
    input.prop("checked", false);
};

window.handleErrorSwal = function handleErrorSwal(HttpRequest, textStatus = null, errorThrown = null) {
    if (HttpRequest.readyState == 4) {
        // HTTP error (can be checked by HttpRequest.status and HttpRequest.statusText)
        return Swal.showValidationMessage(`Ocorreu uma falha`);
    }
    if (HttpRequest.readyState == 0) {
        // Network error (i.e. connection refused, access denied due to CORS, etc.)
        return Swal.showValidationMessage(`Falha na sua conexão`);
    }
    if (HttpRequest.readyState != 0 || HttpRequest.readyState != 4) {
        // something weird is happening
        return Swal.showValidationMessage(`Ocorreu uma falha na sua conexão`);
    }
};

window.handleErrorNotifyConnection = function handleErrorNotifyConnection(HttpRequest, textStatus, errorThrown, targetClass = 'body') {
    if (HttpRequest.readyState || false) {
        if (HttpRequest.readyState == 4) {
            // HTTP error (can be checked by HttpRequest.status and HttpRequest.statusText)
            if (HttpRequest.responseJSON != undefined) {
                errorAlertMessage(HttpRequest.responseJSON.errors || null, targetClass);
                return;
            }
            return showNotification("bottom", "center", "Ocorreu uma falha", "danger", targetClass);
        }
        if (HttpRequest.readyState == 0) {
            // Network error (i.e. connection refused, access denied due to CORS, etc.)
            return showNotification("bottom", "center", "Falha na sua conexão", "danger", targetClass);
        }
        if (HttpRequest.readyState != 0 || HttpRequest.readyState != 4) {
            // something weird is happening
            return showNotification("bottom", "center", "Ocorreu uma falha na sua conexão", "danger", targetClass);
        }
        if (HttpRequest.responseJSON != undefined) {
            errorAlertMessage(HttpRequest.responseJSON.errors || null, targetClass);
            return;
        }
    }
};

window.ptBrToFloat = function ptBrToFloat(ptBrString) {
    // Remover ponto de milhar e substituir vírgula decimal por ponto
    var cleanString = ptBrString.replace(/\./g, "").replace(",", ".");

    // Converter a string para float
    var floatValue = parseFloat(cleanString);

    if (ptBrString == NaN) {
        floatValue = null;
    }

    if (ptBrString == "undefined") {
        floatValue = null;
    }

    return floatValue ? floatValue : 0;
};

window.stringToPtBr = function stringToPtBr(valor) {
    if (typeof valor === "undefined") {
        return null;
    }
    var numero = parseFloat(valor);
    if (isNaN(numero)) {
        return null;
    }
    return numero.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

window.getDiscountPercentageInReais = function getDiscountPercentageInReais(priceOriginal, discountPercent) {
    if (
        ![0, priceOriginal, discountPercent].includes(null) &&
        ![undefined, NaN].includes(priceOriginal) &&
        ![undefined, NaN].includes(discountPercent)
    ) {
        var discountReal = (priceOriginal * discountPercent) / 100;

        return discountReal > priceOriginal ? priceOriginal : discountReal;
    }

    return 0;
};

window.removeHtmlGetTime = function removeHtmlGetTime(html) {
    var stringHtml = html;
    //  removeHtmlGetTime
    // Cria um elemento temporário para armazenar o string HTML
    var tempElement = $("<div></div>");
    tempElement.html(stringHtml);

    // Remove as tags HTML
    var stringSemHtml = tempElement.text();

    return stringSemHtml;
};

window.extractPtBrNumbers = function extractPtBrNumbers(texto) {
    // Remove tudo que não seja número, vírgula ou ponto
    var numeros = texto.replace(/[^0-9,.]/g, "");

    // Remove os pontos
    numeros = numeros.replace(/\./g, "");

    // Substitui a vírgula por ponto para garantir um formato numérico válido
    numeros = numeros.replace(/,/g, ".");

    return parseFloat(numeros);
};

window.cleanHtmlCoinPtBr = function cleanHtmlCoinPtBr(value) {
    value = value.toString().replace(/\D/g, "");
    value = value.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    value = value.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    value = value.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return value;
};

window.toggleButtonState = function toggleButtonState(element, status) {
    if (!element) return;

    if (status) {
        addSpinnerToElement(element);
        disableElementButton(element);
    } else {
        enableElementAfterDelay(element);
    }
};

window.addSpinnerToElement = function addSpinnerToElement(element) {
    element.before(`<i class='zoop-gradient-icon fa-solid fa-spinner fa-spin font-size-24'></i>`);
};

window.disableElementButton = function disableElementButton(element) {
    element.addClass("d-none");
    element.addClass("disabled");
    element.attr("disabled", true);
};

window.enableElementAfterDelay = function enableElementAfterDelay(element) {
    setTimeout(() => {
        element.removeClass("d-none");
        $(".zoop-gradient-icon").remove();
        setTimeout(() => {
            element.removeClass("disabled");
            element.attr("disabled", false);
        }, 2000);
    }, 1500);
};

window.handleErrorsAjax = function handleErrorsAjax(error) {
    // internal erros
    if (error.responseJSON == undefined) {
        showNotification("bottom", "center", "Operação indisponível. Contate o suporte.", "danger");
        return;
    }
    // list validation errors
    if (error.responseJSON.errors) {
        errorAlertMessage(error.responseJSON.errors);
        return;
    }
};

window.getOptionsMultiselect = function getOptionsMultiselect(object, alias, plural = true) {
    plural = plural ? `${alias}s` : alias;

    return (resultArray = object.map((el) => ({
        optgroup_id: el.id,
        label: el.name,
        options: el[plural].map((subElement) => ({
            value: subElement.id,
            name: subElement.name,
            checked: Boolean(subElement.checked),
            attributes: {
                disabled: Boolean(subElement.disabled),
                [alias]: subElement.name,
                [`${alias}_id`]: subElement.id,
            },
        })),
    })));
};

window.refreshMultiselect = function refreshMultiselect(buttonSearch, data, flag, plural = true) {
    buttonSearch.empty();
    let array = getOptionsMultiselect(data, flag, plural);
    buttonSearch.multiselect("loadOptions", array);
    return array;
};

window.resetInpuMultiselect = function resetInpuMultiselect(input, total = 0) {
    if (total == 0) {
        input.empty();
        input.multiselect("reset");
    }
};

window.bootstrapDualListboxPtBr = function bootstrapDualListboxPtBr(input) {
    input.bootstrapDualListbox({
        // selectedListLabel: 'Total selecionadas',
        filterPlaceHolder: "Pesquisar",
        filterTextClear: "Mostrar todas",
        infoText: "Total {0}",
        infoTextEmpty: "Lista vazia",
        infoTextFiltered: '<span class="label label-warning">Encontrado</span> {0} de {1}',
        moveAllLabel: "Mover todos",
        moveOnSelect: false,
        moveSelectedLabel: "Mover selecionado",
        preserveSelectionOnMove: "moved",
        removeAllLabel: "Remover todos",
        removeSelectedLabel: "Remover selecionado",
    });
    let dualListContainer = input.bootstrapDualListbox("getContainer");
    dualListContainer.find(".info-container button").remove();
    dualListContainer.find(".moveall i").removeClass().addClass("fa fa-arrow-right");
    dualListContainer.find(".removeall i").removeClass().addClass("fa fa-arrow-left");
    dualListContainer.find(".move i").removeClass().addClass("fa fa-arrow-right");
    dualListContainer.find(".remove i").removeClass().addClass("fa fa-arrow-left");
};

window.refreshBootstrapDualListbox = function refreshBootstrapDualListbox(input, data, alias) {
    input.children().remove();
    let elemente = `#${input.attr("id")}`;
    let plural = `${alias}s`;
    $.map(data[plural], function (val, i) {
        $("<option>")
            .text(val.name)
            .val(val.id)
            .appendTo(elemente)
            .attr("selected", Boolean(val.checked))
            .prop("disabled", Boolean(val.disabled));
    });

    $(elemente).bootstrapDualListbox("refresh", true);
};

window.startMultiselect = function startMultiselect() {
    if ($(".selectMultiselect").length) {
        $(".selectMultiselect").multiselect({
            columns: 2,
            search: true,
            selectAll: true,
            selectGroup: true,
            texts: {
                placeholder: "Selecione as opções",
                search: "Procurar",
                searchNoResult: "Sem resultados",
                selectedOptions: " selecionado",
                selectAll: "Selecionar tudo",
                unselectAll: "Desmarque todos",
                noneSelected: "Nenhum selecionado",
            },
        });
    }
};

/**
 * Initializes the number spinner functionality.
 */
window.startNumberSpinner = function startNumberSpinner() {
    $(".number-spinner .ns-btn > a").on('click', function (event) {
        event.preventDefault();
        changeSpinnerValue($(this), $(this).data("dir"));
    })

    $("body").on("input", ".number-spinner input", function (event) {
        return validateNumericInput(event);
    });
};

window.startStormClone = function startStormClone() {
    if ($(".storm-clone-group").length) {
        $(".storm-clone-group").stormClone({
            targetBtnRemove: ".target-btn-remove",
            required: true,
            postAddFunction: function () {
                startSelect2Package();
                startToogle();
                startNumberSpinner();
                startPercentageMask();
                startSummernote();
                startDiscountType({
                    percentageClass: `.nav-percentage`,
                    realClass: `.nav-real`,
                    navGroupPayClass: `.nav-group-pay`,
                    setInputHiddenDiscountType: `.targetDiscountTypeId`,
                });
                startSetServicesInSelect2();
                handleCalculatorGroup()
            },
        });
    }
};

window.startToogle = function startToogle() {
    $(".toggleAction").on("click", function () {
        let status = Boolean($(this).prop("checked"));
        $(this).val(status ? 1 : 0);
    });
};

window.handleToggle = function () {
    class ToggleAction {
        constructor(inputClass) {
            this.inputClass = inputClass;
            this.init();
        }

        init() {
            if ($(`${this.inputClass}`).length) {
                $(`${this.inputClass}`).on("click", (event) => this.toggle(event.currentTarget));
            }
        }

        toggle(element) {
            const status = $(element).prop("checked");
            const inputId = $(element).attr('id');
            this.updateValue(inputId, status);
        }

        updateValue(inputId, status) {
            const value = status ? '1' : '0';
            $(`[name="${inputId}"]`).val(value);
            $(`[id="${inputId}"]`).val(value);
        }
    }
    new ToggleAction('.toggleActionStart');
};

handleToggle();

window.validAllStepForm = function validAllStepForm() {
    $(".step-form-validate").each(function () {
        setFormValidation(`#${this.id}`);
    });
};

window.resetAllStepFormValidate = function resetAllStepFormValidate() {
    $(".step-form-validate").each(function () {
        resetStepFormValidate(`#${this.id}`);
    });
};

window.resetStepFormValidate = function resetStepFormValidate(nameForm) {
    let validator = $(`${nameForm}`).validate();
    validator.resetForm();
    $(`${nameForm}`).valid();
};

window.stringToBoolean = function stringToBoolean(str) {
    if (typeof str == "string") {
        switch (str.toLowerCase().trim()) {
            case "true":
            case "yes":
            case "1":
                str = true;
                break;

            case "false":
            case "no":
            case "0":
            case null:
                str = false;
                break;

            default:
                str = false;
        }
        return str;
    }

    if (typeof str == "boolean") {
        let regexPattern = new RegExp("true");
        return regexPattern.test(str);
    }

    return false;
};

window.handleMessageErrors = function handleMessageErrors(jqXHR, textStatus, errorThrown, alertClassTargetMessage = "body") {
    const response = jqXHR?.responseJSON;
    if (textStatus === "error" && jqXHR.status === 0) {
        showNotification("bottom", "center", "Detectamos falha na sua conexão com a internet.", "danger", alertClassTargetMessage);
        return false;
    }

    if (response?.errors && response?.message) {
        errorAlertMessage(jqXHR.responseJSON.errors, alertClassTargetMessage);
        return false;
    }

    showNotification("bottom", "center", "Ops, ocorreu uma falha.", "danger", alertClassTargetMessage);
    return false;
};

window.handleMessageModalErrors = function handleMessageModalErrors(jqXHR, textStatus, errorThrown, targe_class = 'body') {
    const response = jqXHR?.responseJSON;
    if (textStatus === "error" && jqXHR.status === 0) {
        showNotification("bottom", "center", "Detectamos falha na sua conexão com a internet.", "danger", targe_class);
        return false;
    }

    if (response?.errors && response?.message) {
        errorAlertMessage(jqXHR.responseJSON.errors, targe_class);
        return false;
    }

    showNotification("bottom", "center", "Ops, ocorreu uma falha.", "danger", targe_class);
    return false;
};

window.handleMessageSuccess = function handleMessageSuccess(config) {
    Swal.fire({
        title: config.title || "TITULO",
        icon: "success",
        text: config.message || "",
        confirmButtonClass: "btn btn-success",
        buttonsStyling: false,
    }).then((result) => {
        const hasRedirect = config.redirect;
        if (hasRedirect) {
            handleMessageSuccessReloadPageIfConfirmed(config);
        }
        if (config.refresh ?? false) {
            location.reload();
        }
    });
};

window.handleMessageSuccessReloadPageIfConfirmed = function handleMessageSuccessReloadPageIfConfirmed(config) {
    window.location.href = config.redirect;
};

window.handleDatatableReport = function handleDatatableReport(config) {
    let handleConfig = {
        element_table: config.element_table || "ELEMENT_NOT_SELECTED",
        url: config.url || null,
        columns: config.columns || [{}],
        buttons: config.buttons || [],
    };


    $.fn.dataTable.ext.errMode = "none";
    let tableReport = $(handleConfig.element_table).DataTable({
        serverSide: true,
        responsive: true,
        searchable: false,
        searching: false,
        lengthMenu: [
            [10, 30, 50, -1],
            [10, 30, 50, "Todos"],
        ],
        language: {
            url: "/js/jquery-datatables-pt-br.json",
        },
        ajax: {
            url: handleConfig.url,
            data: config.my_function || function (d) { },
        },
        columns: handleConfig.columns,
        dom: "<'row'<'col-12'r>><'row'<'col-5'l><'col-7 text-right'f>>" +
            "<'row'<'col-sm-12'B>><'row'<'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12't>><'row'<'col-5'i><'col-7'p>>",
        buttons: {
            dom: {
                button: {
                    tag: 'button',
                    className: 'btn btn-outline-primary mr-1 '
                }
            },
            buttons: createObjectWithFlagDatatableReport(config.buttons),
        },
        "footerCallback": function (row, data, start, end, display) {
            var api = this.api();
            let footerInfo = api.ajax.json().footerInfo;
            $(api.column(footerInfo.value_total_position).footer()).html(footerInfo.value_total || 0);
        }
    });

    tableReport.on("order.dt search.dt", function () {
        tableReport
            .column(0, {
                search: "applied",
                order: "applied",
            })
            .nodes()
            .each(function (cell, i) {
                cell.innerHTML = i + 1;
            });
    }).draw();

    tableReport.on("draw.dt", function () {
        $('[data-toggle="tooltip"]').tooltip({
            animated: "fade",
            placement: "right",
            html: true,
        });
    });
};

window.newExportAction = function newExportAction(e, dt, button, config) {
    var self = this;
    var oldStart = dt.settings()[0]._iDisplayStart;
    dt.one("preXhr", function (e, s, data) {
        // Just this once, load all data from the server...
        data.start = 0;
        data.length = 2147483647;
        dt.one("preDraw", function (e, settings) {
            // Call the original action function
            if (button[0].className.indexOf("buttons-excel") >= 0) {
                $.fn.dataTable.ext.buttons.excelHtml5.available(dt, config)
                    ? $.fn.dataTable.ext.buttons.excelHtml5.action.call(self, e, dt, button, config)
                    : $.fn.dataTable.ext.buttons.excelFlash.action.call(self, e, dt, button, config);
            } else if (button[0].className.indexOf("buttons-pdf") >= 0) {
                $.fn.dataTable.ext.buttons.pdfHtml5.available(dt, config)
                    ? $.fn.dataTable.ext.buttons.pdfHtml5.action.call(self, e, dt, button, config)
                    : $.fn.dataTable.ext.buttons.pdfFlash.action.call(self, e, dt, button, config);
            } else if (button[0].className.indexOf("buttons-print") >= 0) {
                $.fn.dataTable.ext.buttons.print.action(e, dt, button, config);
            }
            dt.one("preXhr", function (e, s, data) {
                // DataTables thinks the first item displayed is index 0, but we're not drawing that.
                // Set the property to what it was before exporting.
                settings._iDisplayStart = oldStart;
                data.start = oldStart;
            });
            // Reload the grid with the original page. Otherwise, API functions like table.cell(this) don't work properly.
            setTimeout(dt.ajax.reload, 0);
            // Prevent rendering of the full data to the DOM
            return false;
        });
    });
    // Requery the server with the new one-time export settings
    dt.ajax.reload();
}

window.createObjectWithFlagDatatableReport = function createObjectWithFlagDatatableReport(array) {
    if (array) {
        const objects = [];

        array.forEach(flag => {
            let object = {};

            switch (flag) {
                case 'print':
                    object = {
                        extend: "print",
                        text: "<i class='fas fa-print'></i> Print",
                        className: 'btn-primary',
                        footer: true,
                        title: 'zoop',
                        autoPrint: true,
                        orientation: 'landscape',
                        pageSize: 'A4',
                        action: newExportAction,
                        footer: true
                    };
                    break;
                case 'excelHtml5':
                    object = {
                        extend: "excelHtml5",
                        text: "<i class='far fa-file-excel'></i> Excel",
                        className: 'btn-primary bg-zoop',
                        action: newExportAction,
                        exportOptions: {
                            format: {
                                body: function (data, row, column, node) {
                                    data = $('<p>' + data + '</p>').text();
                                    return $.isNumeric(data.replace(',', '.')) ? data.replace(',', '.') : data;
                                }
                            }
                        },
                        footer: true,
                    };
                    break;
                case 'pdfHtml5':
                    object = {
                        extend: "pdfHtml5",
                        text: "<i class='far fa-file-pdf'></i> PDF",
                        className: 'btn-primary',
                        footer: true,
                        title: 'Zoop',
                        filename: 'zoop-report',
                        orientation: 'landscape',
                        pageSize: 'A4',
                        exportOptions: {
                            columns: [2, 3, 4, 5, 6, 7, 11, 13, 14, 15, 17]
                        },
                        customize: function (doc) {
                            doc.content[1].table.widths = [
                                '5%', '12%', '12%', '5%', '12%', '8%', '15%', '8%', '10%',
                                '10%', '10%'
                            ];
                        },
                        action: newExportAction,
                        footer: true,
                    };
                    break;
                default:
                    break;
            }
            objects.push(object);
        });
        return objects;
    }

    return [];
}

window.getValMultibleCheck = function getValMultibleCheck(inputName) {
    let checkedValues = [];
    // Percorre todas as checkboxes marcadas e armazena seus valores no array
    $(inputName).each(function () {
        if ($(this).prop('checked')) {
            checkedValues.push($(this).val());
        }
    });
    return checkedValues;
}
let NAVBAR_SEARCH = "#navbar_search";

window.initializeNavbarSearch = function initializeNavbarSearch() {
    handleAutocompleteSearch({
        input: NAVBAR_SEARCH,
        url: `/navbarSearch`
    });
}

window.handleAutocompleteSearch = function handleAutocompleteSearch(config) {
    class AutocompleteSearch {
        constructor(
            config,
            templates
        ) {
            this.inputName = config.input;
            this.templates = templates;
            this.endpoint = config.url;
            this.loadingIndicator = this.createLoadingIndicator();
            this.initialize();
        }

        initialize() {
            const input = document.querySelector(this.inputName);
            if (input) {
                this.setupAutocomplete(input);
                this.setupEventHandlers();
            }
        }

        setupAutocomplete(input) {
            autocomplete({
                input: input,
                debounceWaitMs: 300,
                minLength: 3,
                render: this.handleAutocomplete.bind(this),
                customize: this.handleContent.bind(this),
                fetch: this.fetchData.bind(this),
                onSelect: this.onSelectItem.bind(this),
                onLoad: () => this.showLoadingIndicator(input),
                onLoadEnd: () => this.hideLoadingIndicator()
            });
        }

        setupEventHandlers() {
            $(`${this.inputName}`).focus();
            $(`${this.inputName}`).on("change", this.handleChange.bind(this));
        }

        handleAutocomplete(item) {
            const div = document.createElement("div");
            div.innerHTML = this.getHtml(item);
            return div;
        }

        getHtml(item) {
            const template = this.templates[item.navbar_type_id] || this.templates.default;
            return template(item);
        }

        handleContent(input, inputRect, container, maxHeight) {
            this.addClassIfContainsHr(container);
            $(container).children().addClass("text-uppercase");
            container.style.maxHeight = maxHeight < 100 ? "200px" : container.style.maxHeight;
            container.style.overflowY = "auto";
            container.style.zIndex = "99999";
        }

        addClassIfContainsHr(container) {
            $('[last_element="true"]').each(function () {
                $(this).parent().after(AutocompleteSearch.pageBreakTemplate());
            });
        }

        static pageBreakTemplate() {
            return `<section class="disabled"><hr style="background:#a9a9a9;margin-top: 0rem;margin-bottom: 0rem;"></section>`;
        }

        fetchData(text, update) {
            this.showLoadingIndicator(document.querySelector(this.inputName));
            return $.ajax({
                url: this.endpoint,
                method: `get`,
                data: {
                    'text': text.toLowerCase()
                },
                global: false,
            })
                .then(response => {
                    update(response.data);
                    return true;
                })
                .catch(handleMessageErrors)
                .always(() => this.hideLoadingIndicator());  // Usando `always` em vez de `finally`
        }

        showLoadingIndicator(input) {
            if (!input) return;

            const inputRect = input.getBoundingClientRect();
            if (!this.loadingIndicator) {
                this.loadingIndicator = this.createLoadingIndicator();
            }
            this.loadingIndicator.style.top = `${inputRect.bottom + window.scrollY}px`;
            this.loadingIndicator.style.left = `${inputRect.left}px`;
            document.body.appendChild(this.loadingIndicator);
        }

        hideLoadingIndicator() {
            if (this.loadingIndicator && this.loadingIndicator.parentNode) {
                this.loadingIndicator.parentNode.removeChild(this.loadingIndicator);
            }
        }

        createLoadingIndicator() {
            const indicator = document.createElement("div");
            indicator.className = "loading-indicator";
            indicator.style.position = "absolute";
            indicator.style.background = "rgba(0, 0, 0, 0.5)";
            indicator.style.color = "#fff";
            indicator.style.padding = "5px";
            indicator.style.borderRadius = "3px";
            indicator.innerText = "Carregando...";
            return indicator;
        }

        onSelectItem(item, input) {
            input.value = item.name;
            this.syncInfo(item);
        }

        syncInfo(item) {
            const syncMethods = {
                1: this.syncSchedule,
                2: this.syncTutor,
                3: this.syncPet,
            };
            const syncMethod = syncMethods[item.navbar_type_id] || (() => { });
            syncMethod.call(this, item);
            this.resetInputs(item);
        }

        syncSchedule(item) {
            getScheduleItems(item.id, true, item.company_id || null);
        }

        syncTutor(item) {
            this.redirectTo(item.url_redirect);
        }

        syncPet(item) {
            this.redirectTo(item.url_redirect);
        }

        resetInputs(item) {
            $(this.inputName).val(item.name ?? "");
        }

        handleChange(event) {
            const value = event.target.value;
            if (!value || value.length < 3) {
                this.syncInfo(false);
            }
        }

        redirectTo(route) {
            if (route) {
                window.location.href = route;
            }
        }
    }
    const searchTemplates = {
        1: (item) => `
            <div last_element="${item.last_element}">
                <div class="${item.class ?? ''}">
                    ${item.icon} ${item.name} - ${item.text_start_date}
                    <div><span class="badge badge-pill text-bold " style="padding: 1px 12px;font-size: 10px;${item.style_status}">${item.text_status}</span></div>
                </div>
            </div>
        `,
        2: (item) => `
            <div last_element="${item.last_element}">
                <div class="text-uppercase">
                    ${item.icon} ${item.name}
                    <div class="font-weight-bold">
                        ${item.cpf} ${item.email}
                    </div>
                </div>
            </div>
        `,
        3: (item) =>
            `<div class="${item.class ?? ''}" last_element="${item.last_element}">${item.icon} ${item.name} <div class="font-weight-bold">(${item.text_tutors})</div></div>`,
        default: (item) => `${item.icon} ${item.name}`
    };
    new AutocompleteSearch(config, searchTemplates);
}

initializeNavbarSearch();


window.handleModalEditDataTable = async function handleModalEditDataTable(element, config = {}) {
    let subTitleModal = $('#sub_title_modal');
    let modalCall = $('#modalEdit');
    const modalTitle = element.data('name');
    const url = element.data('url-modal');

    if (!url) {
        return; // Exit the function if url-modal doesn't exist
    }

    subTitleModal.text(modalTitle);
    modalCall.modal({
        backdrop: 'static',
        keyboard: false
    });

    try {
        const html = await $.get(url);
        modalCall.find('.modal-body').empty().append(html);
        modalCall.modal('show');
        if (config?.addFunction) {
            config.addFunction();
        }
    } catch (error) {
        handleDataTablesErrorDataTable(error);
    }
}

window.handleDataTablesErrorDataTable = async function handleDataTablesErrorDataTable(error) {
    const response = error?.responseJSON;

    let title = "Ocorreu uma falha";
    if (response?.exception) {
        title = "Ocorreu uma falha";
    } else if (response?.errors && response?.message) {
        title = response.message;
    }

    Swal.fire({
        title: title,
        icon: "error",
        confirmButtonClass: "btn btn-success",
        buttonsStyling: false,
    });
}

window.copyToClipboard = function copyToClipboard(event) {
    // Get the text field
    var copyText = document.getElementById("myInput");

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText.value);
}

class ColorGenerator {
    static getDynamicColor() {
        const r = Math.floor(Math.random() * 255);
        const g = Math.floor(Math.random() * 255);
        const b = Math.floor(Math.random() * 255);
        return `rgb(${r},${g},${b})`;
    }

    static getRgbColors(data) {
        return data.map(() => this.getDynamicColor());
    }
}

class DateInterval {
    constructor() {
        this.searchParams = new URLSearchParams(window.location.search);
        this.dateInterval = this.searchParams.get("store_performance_start_date");
        this.start = moment().startOf("month").format("DD/MM/YYYY");
        this.end = moment().endOf("month").format("DD/MM/YYYY");
    }

    getInterval() {
        if (this.dateInterval) {
            const [start, end] = this.dateInterval.split(" - ");
            this.start = start;
            this.end = end;
        }

        return {
            start: this.start,
            end: this.end,
        };
    }
}

window.handleZipCode = function (config = {}) {
    class HandleZipCode {
        constructor(config) {
            this.input = $(`#${config.inputId}`);
            this.searchButton = $(`#${config.searchButtonId}`);
            this.inputFields = config.inputFields;
            this.fieldCep = $("#form-group-cep");
            this.debounceTimer = null;

            this.init();
        }

        init() {
            this.setupInputMask();
            this.setupDebounce();
            this.setCsrfToken();
        }

        setupInputMask() {
            this.input.inputmask({
                mask: '99999-999',
                autoUnmask: true,
                showMaskOnFocus: true,
            });
        }

        setupDebounce() {
            this.searchButton.on('click', () => this.getCep());
            this.input.on('input', () => {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => this.getCep(), 300);
            });

            const numberInput = $(this.inputFields.number ?? '');
            numberInput.on('input', () => {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => this.getCep(), 300);
            });
        }

        setCsrfToken() {
            const csrfToken = $('meta[name="csrf-token"]').attr('content');
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                },
            });
        }

        getCep() {
            this.fieldCep.removeClass('has-danger has-success');
            const zipCode = this.input.val();
            const numberAdress = $(this.inputFields.number ?? '').val();
            if (!this.isValidZip(zipCode)) {
                this.fieldCep.addClass('has-danger');
                return;
            }

            // Desativa os inputs durante a requisição
            this.toggleInputs(false);

            $.ajax({
                url: `/companies/addresses/findZipCode?zip_code=${zipCode}&number=${numberAdress}`,
                dataType: 'json',
                success: (data) => this.handleResponse(data),
                error: () => this.toggleInputs(true), // Reativa os inputs em caso de falha
                complete: () => this.toggleInputs(true) // Reativa os inputs após a finalização
            });
        }

        isValidZip(zipCode) {
            return zipCode && zipCode.length >= 8;
        }

        handleResponse(data) {
            if (data.erro) {
                this.fieldCep.addClass('has-danger');
                this.clearFields();
            } else {
                this.fillFields(data.data);
                this.fieldCep.removeClass('has-danger').addClass('has-success');
            }
        }

        fillFields(data) {
            $(this.inputFields.street ?? '').val(data.street);
            $(this.inputFields.district ?? '').val(data.district);
            $(this.inputFields.city ?? '').val(data.city);
            $(this.inputFields.uf ?? '').val(data.uf);
            $(this.inputFields.latitude ?? '').val(data.latitude);
            $(this.inputFields.longitude ?? '').val(data.longitude);
            $(this.inputFields.number ?? '').val(data.number);
        }

        clearFields() {
            $("#enderecoForm")[0].reset();
        }

        // Função para ativar/desativar inputs
        toggleInputs(enable) {
            $("#number, #zip_code").prop('disabled', !enable);
        }
    }

    new HandleZipCode(config);
}

window.handleDoughnutChart = function (config) {
    class DoughnutChart {
        constructor(config) {
            this.canvasId = config.canvasId;
            this.data = config.data;

            this.chartConfig = {
                type: 'doughnut',
                data: this.createData(),
                options: this.createOptions()
            };

            this.initChart();
        }

        createData() {
            return this.data;
        }

        createOptions() {
            return {
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true
                },
                plugins: {
                    responsive: true,
                    datalabels: {
                        formatter: (value, ctx) => {
                            const sum = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                            return ((value * 100 / sum).toFixed(2) + "%");
                        },
                        color: '#fff',
                    },
                    legend: {
                        position: 'bottom',
                        labels: {
                            usePointStyle: true,
                            pointStyle: 'circle'
                        }
                    },
                }
            };
        }

        initChart() {
            const canvasElement = $(`${this.canvasId}`);
            if (canvasElement.length === 0) {
                return;
            }
            const elementChart = canvasElement[0].getContext('2d');
            new Chart(elementChart, this.chartConfig);
        }
    }
    new DoughnutChart(config);
}

window.handleLineChart = function (config) {

    class ChartRenderer {
        constructor(chartId, data = [], defaultDatasetStyle = {}) {
            this.chartId = chartId;
            this.chartType = 'line';
            this.data = this.formatData(data, defaultDatasetStyle);
            this.options = this.mergeOptions({});
            this.chart = null;
        }

        formatData(data, defaultDatasetStyle) {
            if (!Array.isArray(data)) {
                throw new Error('Data must be an array of datasets.');
            }

            // Combinar todos os labels e datasets
            const combinedLabels = new Set();
            const combinedDatasets = {};

            data.forEach(entry => {
                entry.labels.forEach(label => combinedLabels.add(label));
                entry.datasets.forEach(dataset => {
                    if (!combinedDatasets[dataset.label]) {
                        combinedDatasets[dataset.label] = {
                            ...defaultDatasetStyle, // Aplica as estilizações padrão
                            ...dataset, // Permite sobrescrever estilos por dataset
                            data: {},
                        };
                    }

                    entry.labels.forEach((label, index) => {
                        combinedDatasets[dataset.label].data[label] =
                            dataset.data[index] || 0; // Valor padrão caso não tenha um dado para o label
                    });
                });
            });

            // Converter os dados combinados para o formato de array
            const labelsArray = Array.from(combinedLabels).sort(); // Garantir ordenação consistente
            const datasetsArray = Object.values(combinedDatasets).map(dataset => ({
                ...dataset,
                data: labelsArray.map(label => dataset.data[label] || 0),
            }));

            return {
                labels: labelsArray,
                datasets: datasetsArray,
            };
        }

        mergeOptions(customOptions) {
            const defaultOptions = {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            fontColor: '#000',
                        },
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            stepSize: 1,
                        },
                    },
                },
            };

            return { ...defaultOptions, ...customOptions };
        }

        renderChart() {
            const canvasElement = $(`${this.chartId}`);
            if (canvasElement.length === 0) {
                return;
            }
            const elementChart = canvasElement[0].getContext('2d');
            new Chart(elementChart, {
                type: this.chartType,
                data: this.data,
                options: this.options,
            });
        }
    }

    // Configuração padrão para os datasets
    const defaultDatasetStyle = {
        backgroundColor: 'rgba(255, 27, 183, 0.3)',
        borderColor: 'rgb(255, 27, 183)',
        fill: true,
        tension: 0.3,
        pointRadius: 5,
        pointHoverRadius: 5,
    };

    const chart = new ChartRenderer(config.canvasId, config.data, defaultDatasetStyle);
    chart.renderChart();
}

window.handleDateRangePicker = function (config) {
    class DateRangePicker extends DateInterval {
        constructor(config) {
            const { start, end } = new DateInterval().getInterval();
            super();
            this.inputName = config.inputName;
            this.start = start;
            this.end = end;
            this.initPicker();
        }

        initPicker() {
            $(`${this.inputName}`).daterangepicker({
                showDropdowns: true,
                showWeekNumbers: true,
                alwaysShowCalendars: true,
                startDate: this.start,
                endDate: this.end,
                locale: this.getLocale(),
                ranges: this.getRanges()
            });
        }

        getLocale() {
            return {
                format: "DD/MM/YYYY",
                customRangeLabel: "Customizar",
                applyLabel: "Ok",
                cancelLabel: "Cancelar",
                monthNames: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dec"],
                daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            };
        }

        getRanges() {
            return {
                Hoje: [moment(), moment()],
                "Últimos 7 dias": [moment().subtract(7, "days"), moment()],
                "Últimos 15 dias": [moment().subtract(15, "days"), moment()],
                "Últimos 30 dias": [moment().subtract(30, "days"), moment()],
                "Este mês": [moment().startOf("month"), moment().endOf("month")],
            };
        }
    }
    new DateRangePicker(config);
}

window.handleLiveSearch = function (config) {
    class LiveSearch {
        constructor(config) {
            this.inputName = config.inputName;
            this.url = config.url;
            this.placeholder = config.placeholder;
            this.data = config.data ?? {};
            this.init();
        }

        init() {
            $(this.inputName).select2({
                closeOnSelect: false,
                placeholder: this.placeholder,
                allowClear: true,
                global: false,
                minimumResultsForSearch: Infinity,
                language: this.getLanguageSettings(),
                ajax: this.getAjaxSettings(),
            });

            $(this.inputName).next("span.select2-container")
                .css("width", "100%")
                .css("flex-grow", "1")
                .css("box-sizing", "border-box")
                .css("display", "inline-block")
                .css("margin", "0")
                .css("position", "relative")
                .css("vertical-align", "middle");

            $(this.inputName).next("span.select2-container").find('.select2-search__field').each(function () {
                this.style.setProperty('position', 'unset', 'important');
                this.style.setProperty('white-space', 'nowrap', 'important');
                this.style.setProperty('padding-bottom', '0px', 'important');
                this.style.setProperty('display', 'inline', 'important');
                this.style.setProperty('list-style', 'none', 'important');
                this.style.setProperty('font-size', '14px', 'important');
                this.style.setProperty('height', '25px', 'important');
                this.style.setProperty('padding-top', '4px', 'important');
                this.style.setProperty('padding-left', '10px', 'important');
                this.style.setProperty('min-width', '40px', 'important');
            });
        }

        getAjaxSettings() {
            return {
                data: params => this.getMergedData(params),
                url: this.url,
                dataType: 'json',
                delay: 250,
                processResults: (data) => {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item.name,
                                id: item.id
                            };
                        })
                    };
                },
                cache: true
            };
        }

        getMergedData(params) {
            return {
                search: params.term ?? 0,
                q: params.term ?? 0,
                _type: 'query',
                ...this.data
            };
        }

        getLanguageSettings() {
            return {
                maximumSelected: args => `Você pode selecionar apenas ${args.maximum} item${args.maximum > 1 ? 's' : ''}`,
                noResults: () => "Nenhum resultado encontrado",
                inputTooShort: function (args) {
                    var remainingChars = args.minimum - args.input.length;
                    return "Please enter " + remainingChars + " or more characters to search"; // Custom message
                },
                errorLoading: function () {
                    return "Resultado não encontrado";
                },
            };
        }
    }
    new LiveSearch(config);
}

window.handleSelect2 = function (config) {
    class handleSelect2 {
        constructor(config) {
            this.selector = config?.selector ?? ".sel2";
            this.init();
        }

        init() {
            $(this.selector).select2({
                allowClear: true,
                closeOnSelect: false,
                width: 'resolve',
                minimumResultsForSearch: Infinity,
                placeholder: "Pesquisar",
                minimumInputLength: config?.minimumInputLength ?? 0,
                language: this.getLanguageSettings(),
            });

            $(this.selector).next("span.select2-container")
                .css("width", "100%")
                .css("flex-grow", "1")
                .css("box-sizing", "border-box")
                .css("display", "inline-block")
                .css("margin", "0")
                .css("position", "relative")
                .css("vertical-align", "middle");

            $(this.selector).next("span.select2-container").find('.select2-search__field').each(function () {
                this.style.setProperty('position', 'unset', 'important');
                this.style.setProperty('white-space', 'nowrap', 'important');
                this.style.setProperty('padding-bottom', '0px', 'important');
                this.style.setProperty('display', 'inline', 'important');
                this.style.setProperty('list-style', 'none', 'important');
                this.style.setProperty('font-size', '14px', 'important');
                this.style.setProperty('height', '25px', 'important');
                this.style.setProperty('padding-top', '4px', 'important');
                this.style.setProperty('padding-left', '10px', 'important');
                this.style.setProperty('min-width', '40px', 'important');
            });
        }

        getLanguageSettings() {
            return {
                maximumSelected: args => `Você pode selecionar apenas ${args.maximum} item${args.maximum > 1 ? 's' : ''}`,
                noResults: () => "Nenhum resultado encontrado",
                inputTooShort: function (args) {
                    var remainingChars = args.minimum - args.input.length;
                    return "Please enter " + remainingChars + " or more characters to search"; // Custom message
                },
                errorLoading: function () {
                    return "Resultado não encontrado";
                },
            };
        }
    }

    new handleSelect2(config);
};

window.handleCheckboxManager = function (config) {
    class CheckboxManager {
        constructor(config) {
            this.selectedCheckboxes = new Set();
            this.inputElement = document.getElementById(config.inputName);
            this.container = document.querySelector(config.containerSelector);
            this.selectAllCheckbox = document.getElementById('select_all');
            this.checkboxesSelector = 'input[type="checkbox"].check_schedule'; // Só checkboxes com essa classe
            this.maxSelections = config.options.maxSelections || 700;
            this.maxSelectionsAlias = config.options.maxSelectionsAlias || `Você só pode selecionar no máximo: ${this.maxSelections}.`;
            this.bindEvents();
        }

        bindEvents() {
            this.container.addEventListener('change', this.handleCheckboxChange.bind(this));
            if (this.selectAllCheckbox) {
                this.selectAllCheckbox.addEventListener('change', this.handleSelectAll.bind(this));
            }
            $(document).on('click', '.paginate_button', this.resetSelectAll.bind(this));
        }

        handleCheckboxChange(event) {
            const checkbox = event.target;
            if (checkbox.matches(this.checkboxesSelector)) { // Verifica se o checkbox tem a classe correta
                checkbox.checked ? this.selectCheckbox(checkbox) : this.unselectCheckbox(checkbox);
                this.handleMessageMaxSelections();
            }
        }

        handleSelectAll() {
            const selectAll = this.selectAllCheckbox.checked;
            const checkboxes = this.container.querySelectorAll(this.checkboxesSelector);
            checkboxes.forEach(checkbox => {
                if (selectAll && this.selectedCheckboxes.size < this.maxSelections) {
                    this.selectCheckbox(checkbox);
                } else if (!selectAll) {
                    this.unselectCheckbox(checkbox);
                }
            });
        }

        selectCheckbox(checkbox) {
            if (this.selectedCheckboxes.size < this.maxSelections) {
                this.selectedCheckboxes.add(checkbox.value);
                checkbox.checked = true;
            } else {
                checkbox.checked = false;
            }
            this.updateSelections();
        }

        unselectCheckbox(checkbox) {
            this.selectedCheckboxes.delete(checkbox.value);
            checkbox.checked = false;
            this.updateSelections();
        }

        updateSelections() {
            this.inputElement.value = Array.from(this.selectedCheckboxes).join(',');
            window.selectedCheckboxes = Array.from(this.selectedCheckboxes);
        }

        handleMessageMaxSelections() {
            if (this.selectedCheckboxes.size >= this.maxSelections) {
                showNotification("bottom", "center", `${this.maxSelectionsAlias}.`, "warning");
            }
        }

        resetSelectAll() {
            if (this.selectAllCheckbox) {
                this.selectAllCheckbox.checked = false;
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        new CheckboxManager(config);
    });
};

window.handleSelect2Multiple = function handleSelect2Multiple(config) {
    class Select2Handler {
        constructor(
            config,
            templates
        ) {
            this.input = config.input;
            this.endpoint = config.url;
            this.data = config.data ?? {};
            this.templates = templates;
            this.initialize();
        }

        initialize() {
            this.input.select2({
                closeOnSelect: true,
                maximumSelectionLength: 0,
                minimumResultsForSearch: Infinity,
                language: this.getLanguageSettings(),
                ajax: this.getAjaxSettings(),
                cache: true,
                templateResult: this.renderTemplate.bind(this)
            });
        }

        getLanguageSettings() {
            return {
                maximumSelected: args => `Você pode selecionar apenas ${args.maximum} item${args.maximum > 1 ? 's' : ''}`,
                noResults: () => "Nenhum resultado encontrado",
                inputTooShort: function (args) {
                    var remainingChars = args.minimum - args.input.length;
                    return "Please enter " + remainingChars + " or more characters to search"; // Custom message
                },
                errorLoading: function () {
                    return "Resultado não encontrado";
                },
            };
        }

        getAjaxSettings() {
            return {
                url: this.endpoint,
                dataType: 'json',
                delay: 250,
                data: params => this.getMergedData(params),
                processResults: data => this.formatResults(data),
                error: handleMessageModalErrors,
            };
        }

        getMergedData(params) {
            return {
                search: params.term ?? 0,
                q: params.term ?? 0,
                _type: 'query',
                ...this.data
            };
        }

        formatResults(data) {
            return {
                results: data.data.map(item => ({
                    text: item.text,
                    children: item.children.map(child => ({
                        id: child.id,
                        text: child.text,
                        selected: child.selected,
                        html: child.html,
                        template_id: child.template_id ?? 0
                    }))
                }))
            };
        }

        renderTemplate(item) {
            if (!item.id) return item.text;
            const template = this.templates[item.template_id] || this.templates.default;
            return $(template(item));
        }
    }

    const select2Templates = {
        1: function (item) {
            return `<span>${item.html}</span>`;
        },
        default: item => `${item.text}`
    };

    new Select2Handler(config, select2Templates);
}

window.bindSaveEvents = function (config) {
    class bindSaveEvents {
        constructor(config) {
            this.elementMain = config.elementMain || 'body';
            this.modal = (config.modal || false) ? '.modal.show' : 'body';
            this.button = config.button;
            this.formAction = config.formAction || $(config.button).data('url') || '/';
            this.data = typeof config.data === 'function' ? config.data : () => { };
            this.getFormData = typeof config.getFormData === 'string' ?
                () => this.getFormDataBySelector(config.getFormData) :
                (typeof config.getFormData === 'function' ? config.getFormData : () => { });
            this.elementType = $(this.button).prop("type") ?? '';
            this.initialize();
        }

        initialize() {
            $(this.elementMain).on('click', this.button, this.handleClickSave.bind(this));
        }

        handleClickSave(event) {
            if ($(this.button).is("button")) {
                event.preventDefault();
            }
            this.toggleButtonState(true);
            $.ajax({
                url: this.formAction,
                method: 'POST',
                data: this.getMergedData(),
                success: this.handleSuccess.bind(this),
                error: this.handleFailure.bind(this),
                complete: () => this.toggleButtonState(false),
            });
        }

        getMergedData() {
            return {
                ...this.data(),
                ...this.getFormData(),
            };
        }

        handleSuccess(response) {
            handleMessageSuccess({
                title: response.title ?? 'Sucesso',
                message: response.message,
                redirect: response.redirect,
                refresh: response.refresh ?? false,
            });
        }

        handleFailure(jqXHR, textStatus, errorThrown) {
            if (this.elementType == 'checkbox') {
                let previousStatus = this.restoreStatusToogle();
                $(this.button).prop("checked", previousStatus);
            }
            handleMessageErrors(jqXHR, textStatus, errorThrown, this.modal);
        }

        restoreStatusToogle() {
            let status = stringToBoolean($(this.button).val());
            return !status;
        }

        toggleButtonState(state) {
            $(this.button).prop('disabled', state);
        }

        getFormDataBySelector(form) {
            var formData = {};
            $(form).serializeArray().forEach(function (field) {
                formData[field.name] = field.value;
            });
            return formData;
        }
    }
    new bindSaveEvents(config);
};

window.bindSaveByClass = function (config) {
    class bindSaveByClass {
        constructor(config) {
            this.elementMain = config.elementMain || 'body';
            this.actionElement = config.actionElement || 'click';
            this.modal = (config.modal || false) ? '.modal.show' : 'body';
            this.preventDefault = (config.preventDefault ?? false) ? true : config.preventDefault;
            this.button = config.button;
            this.method = config.method || 'POST';
            this.endpoint = config.endpoint || $(config.button).data('url') || '/';
            this.data = typeof config.data === 'function' ? config.data : () => { };
            this.postAddFunction = typeof config.postAddFunction === 'function' ? config.postAddFunction : () => { };
            this.getFormData = typeof config.getFormData === 'string' ?
                () => this.getFormDataBySelector(config.getFormData) :
                (typeof config.getFormData === 'function' ? config.getFormData : () => { });

            this.initialize();
        }

        initialize() {
            $(this.elementMain).on(this.actionElement, this.button, this.bindSaveEvents.bind(this));
        }

        bindSaveEvents(event) {
            if (this.preventDefault) {
                event.preventDefault();
            }
            const button = event.currentTarget;
            this.toggleButtonState(true);
            this.button = $(button);

            $.ajax({
                url: this.endpoint,
                method: this.method,
                data: this.getMergedData(button),
                success: this.handleSuccess.bind(this),
                error: this.handleFailure.bind(this),
                complete: () => this.toggleButtonState(false),
            });
        }

        getMergedData(button) {
            return {
                ...this.data(button),
                ...this.getFormData(),
            };
        }

        handleSuccess(response) {
            this.handleMessageSuccessSave({
                title: response.title ?? 'Sucesso',
                message: response.message,
                redirect: response.redirect,
                refresh: response.refresh ?? false,
            });
        }

        handleMessageSuccessSave(config) {
            Swal.fire({
                title: config.title || "TITULO",
                icon: "success",
                text: config.message || "",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
            }).then((result) => {
                this.postAddFunction(this.button);

                const hasRedirect = config.redirect;
                if (hasRedirect) {
                    handleMessageSuccessReloadPageIfConfirmed(config);
                }
                if (config.refresh ?? false) {
                    location.reload();
                }
            });
        };


        handleFailure(jqXHR, textStatus, errorThrown) {
            handleMessageErrors(jqXHR, textStatus, errorThrown, this.modal);
        }

        toggleButtonState(state) {
            $(this.button).prop('disabled', state);
        }

        getFormDataBySelector(form) {
            var formData = {};
            $(form).serializeArray().forEach(function (field) {
                formData[field.name] = field.value;
            });
            return formData;
        }
    }
    new bindSaveByClass(config);
};

class MaskedInput {
    constructor(inputElement, options = {}) {
        this.inputElement = $(inputElement);
        this.options = options;
        this.setupMask();
    }

    setupMask() {
        const prefix = this.options.prefix || '';
        const precision = typeof this.options.precision === 'number' ? this.options.precision : 2;
        const decimal = this.options.decimal || ',';
        const thousands = this.options.thousands || '.';

        this.inputElement.maskMoney({
            decimal: ",",
            thousands: "."
        });

        this.inputElement.on('paste', (event) => this.handlePaste(event));
    }

    handlePaste(event) {
        const pastedValue = event.originalEvent.clipboardData.getData('text');
        event.preventDefault();

        const numberValue = this.convertToNumber(pastedValue);
        this.setValue(numberValue);
    }

    getValue() {
        return this.convertToNumber(this.inputElement.val());
    }

    convertToNumber(value) {
        if (value) {
            let newValue = value.replace(/\./g, '').replace(',', '.');
            const numberValue = parseFloat(newValue);

            return isNaN(numberValue) ? 0 : numberValue;
        }
        return 0;
    }

    setValue(value) {
        if (value !== null && value !== undefined) {
            const formattedValue = value.toFixed(this.options.precision || 2).replace('.', this.options.decimal || ',');
            this.inputElement.val(formattedValue).trigger('input'); // Garante a aplicação da máscara
        }
    }

    disable() {
        this.inputElement.prop('disabled', true).addClass('disabled');
    }

    enable() {
        this.inputElement.prop('disabled', false).removeClass('disabled');
    }
}

class Calculator {
    constructor(groupElement) {
        this.groupElement = $(groupElement);
        this.typeSelect = this.groupElement.find('.cg-discount-type-id');
        this.inputs = {};
        this.init();
    }

    init() {
        this.groupElement.find('.cg-masked-input').each((index, inputElement) => {
            const inputName = $(inputElement).data('cg-name');
            if (inputName) {
                this.inputs[inputName] = new MaskedInput(inputElement, {
                    type: inputName
                });
            }
        });

        this.setupEventListeners();
        this.updateFields();
    }

    setupEventListeners() {
        this.groupElement.on('change keyup', '.cg-discount-type-id', () => this.updateFields());
        this.groupElement.on('change keyup', '.cg-masked-input', (event) => {
            const inputElement = $(event.target);
            const inputName = inputElement.data('cg-name');

            if (inputName === 'percentage') {
                this.maskPercentage(inputElement);
            }
            if (inputName === 'real') {
                this.maskReal(inputElement);
            }
        });
    }

    maskPercentage(inputElement) {
        const limit = 100;
        const percentage = this.getMaskedInputValue(inputElement);
        if (percentage > limit) {
            this.setMaskedInputValue(inputElement, limit);
        }
    }

    maskReal(inputElement) {
        const limit = 500000.00;
        const realValue = this.getMaskedInputValue(inputElement);
        if (realValue > limit) {
            $(inputElement).val('500.000,00');
        }
    }

    getMaskedInputValue(inputElefment) {
        const inputName = $(inputElement).data('cg-name');
        return this.inputs[inputName] ? this.inputs[inputName].getValue() : 0;
    }

    setMaskedInputValue(inputElement, value) {
        const inputName = $(inputElement).data('cg-name');
        if (this.inputs[inputName]) {
            this.inputs[inputName].setValue(value);
        }
    }

    updateFields() {
        const selectedType = this.typeSelect.val();

        if (selectedType === '1') { // Percentual
            this.inputs['percentage'].enable();
            this.inputs['real'].disable();
        } else if (selectedType === '2') { // Valor Real
            this.inputs['percentage'].disable();
            this.inputs['real'].enable();
        } else { // Nenhum desconto
            this.inputs['percentage'].disable();
            this.inputs['real'].disable();
        }
    }
}

window.handleCalculatorGroup = function () {
    $('.cg-calculator-group').each((index, groupElement) => {
        new Calculator(groupElement);
    });
}

window.handleFileDownloader = function (config) {
    if (config) {
        class FileDownloader {
            constructor(inputElement) {
                this.inputElement = inputElement;
                this.handleComplete = this.handleComplete.bind(this);
            }

            downloadFile(downloadUrl) {
                this.toggleButtonState(true);

                $.ajax({
                    url: downloadUrl,
                    method: 'GET',
                    global: false,
                    xhrFields: {
                        responseType: 'blob'
                    },
                    success: this.handleSuccess.bind(this),
                    error: this.handleError,
                    complete: this.handleComplete
                });
            }

            handleSuccess(data, status, xhr) {
                const url = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.href = url;
                const contentDisposition = xhr.getResponseHeader('Content-Disposition');
                const fileName = contentDisposition ? contentDisposition.split('filename=')[1] :
                    'download.zip';
                a.download = fileName.replace(/"/g, '');
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }

            toggleButtonState(state) {
                this.inputElement.prop('disabled', state);
                this.setClassDisabled(state);

                if (state) {
                    this.addSpinnerToElement();
                    this.disableElementButton();
                } else {
                    this.enableElementAfterDelay();
                }
            }

            disableElementButton() {
                this.inputElement.addClass("d-none");
                this.inputElement.addClass("disabled");
                this.inputElement.attr("disabled", true);
            };

            addSpinnerToElement() {
                this.inputElement.before(
                    `<i class='zoop-gradient-icon fa-solid fa-spinner fa-spin font-size-24'></i>`
                );
            };

            enableElementAfterDelay() {
                setTimeout(() => {
                    this.inputElement.removeClass("d-none");
                    $(".zoop-gradient-icon").remove();
                    setTimeout(() => {
                        this.inputElement.removeClass("disabled");
                        this.inputElement.attr("disabled", false);
                    }, 2000);
                }, 1500);
            };

            setClassDisabled(state) {
                if (state) {
                    this.inputElement.addClass('disabled-element');
                }
                if (!state) {
                    this.inputElement.removeClass('disabled-element');
                }
            }

            handleError(jqXHR, textStatus, errorThrown) {
                showNotification("bottom", "center", "Sem fotos neste ano", "warning")
            }

            handleComplete() {
                this.toggleButtonState(false);
            }
        }

        (new FileDownloader(config.element)).downloadFile(config.downloadUrl);
    }
}

window.handleUpdate = function (config) {
    class handleUpdate {
        constructor(config) {
            this.elementMain = config.elementMain || 'body';
            this.modal = (config.modal || false) ? '.modal.show' : 'body';
            this.button = config.button;
            this.formAction = config.formAction || $(config.button).data('url') || '/';
            this.data = typeof config.data === 'function' ? config.data : () => { };
            this.getFormData = typeof config.getFormData === 'string' ?
                () => this.getFormDataBySelector(config.getFormData) :
                (typeof config.getFormData === 'function' ? config.getFormData : () => { });
            this.elementType = $(this.button).prop("type") ?? '';
            this.initialize();
        }

        initialize() {
            $(this.elementMain).on('click', this.button, this.handleClickUpdate.bind(this));
        }

        handleClickUpdate(event) {
            if ($(this.button).is("button")) {
                event.preventDefault();
            }
            this.toggleButtonState(true);
            $.ajax({
                url: this.formAction,
                method: 'PUT',
                data: this.getMergedData(),
                success: this.handleSuccess.bind(this),
                error: this.handleFailure.bind(this),
                complete: () => this.toggleButtonState(false),
            });
        }

        getMergedData() {
            return {
                ...this.data(),
                ...this.getFormData(),
            };
        }

        handleSuccess(response) {
            handleMessageSuccess({
                title: response.title ?? 'Sucesso',
                message: response.message,
                redirect: response.redirect,
                refresh: response.refresh ?? false,
            });
        }

        handleFailure(jqXHR, textStatus, errorThrown) {
            if (this.elementType == 'checkbox') {
                let previousStatus = this.restoreStatusToogle();
                $(this.button).prop("checked", previousStatus);
            }
            handleMessageErrors(jqXHR, textStatus, errorThrown, this.modal);
        }

        restoreStatusToogle() {
            let status = stringToBoolean($(this.button).val());
            return !status;
        }

        toggleButtonState(state) {
            $(this.button).prop('disabled', state);
        }

        getFormDataBySelector(form) {
            var formData = {};
            $(form).serializeArray().forEach(function (field) {
                formData[field.name] = field.value;
            });
            return formData;
        }
    }
    new handleUpdate(config);
};

class CountdownConfigDTO {
    constructor({ timer, target, onFinish = null }) {
        if (typeof timer !== 'number' || timer <= 0) {
            throw new Error('Timer must be a positive number');
        }

        if (typeof target !== 'string' || !document.querySelector(target)) {
            throw new Error('Target must be a valid selector');
        }

        if (onFinish !== null && typeof onFinish !== 'function') {
            throw new Error('onFinish must be a function or null');
        }

        this.timer = timer;
        this.target = target;
        this.onFinish = onFinish;
    }
}

class CountdownTimer {
    constructor(config) {
        this.timer = config.timer;
        this.targetSelector = config.target;
        this.target = document.querySelector(config.target);
        this.intervalId = null;
        this.onFinish = config.onFinish;

        this.updateDisplay(this.timer);
    }

    start() {
        this.intervalId = setInterval(() => {
            this.target = document.querySelector(this.targetSelector);

            // Se o target sumiu, para o contador
            if (!this.target) {
                console.warn("Elemento alvo removido da DOM. Contador interrompido.");
                this.stop();
                return;
            }

            this.timer--;
            this.updateDisplay(this.timer);

            if (this.timer <= 0) {
                this.stop();
                this.updateDisplay("Tempo esgotado!");
                if (this.onFinish) {
                    this.onFinish();
                }
            }
        }, 1000);
    }

    stop() {
        clearInterval(this.intervalId);
    }

    updateDisplay(message) {
        if (this.target) {
            this.target.textContent = message;
        }
    }
}


window.handleCountdownTimer = function (config) {
    try {
        const dto = new CountdownConfigDTO(config);
        const timer = new CountdownTimer(dto);
        timer.start();
    } catch (error) {
        console.error("Erro ao iniciar o contador:", error.message);
    }
};

class VisibilityToggleDTO {
    constructor({ className, show }) {
        this.className = String(className).trim();
        this.show = this._sanitizeShow(show);

        this._validate();
    }

    _sanitizeShow(value) {
        const falsyStrings = new Set(['0', 'false', '']);
        const normalized = String(value).toLowerCase().trim();

        return !falsyStrings.has(normalized);
    }

    _validate() {
        if (!this.className) {
            throw new Error('className is required and must be a non-empty string.');
        }

        if (typeof this.show !== 'boolean') {
            throw new Error('show must be a boolean.');
        }
    }
}

class VisibilityToggler {
    constructor(dto) {
        this.dto = dto;
    }

    toggle() {
        const $elements = this._findElements();
        this.dto.show ? $elements.show() : $elements.hide();
    }

    _findElements() {
        return $(`.${this.dto.className}`);
    }
}

window.handleVisibilityToggle = function (config) {
    try {
        const dto = new VisibilityToggleDTO(config);
        new VisibilityToggler(dto).toggle();
    } catch (error) {
        console.error('Visibility toggle failed:', error.message);
    }
};
